import styled from 'styled-components'

export const Wrapper = styled.div`
  column-gap: var(--spacer-2);
  row-gap: var(--spacer-1);
`

Wrapper.displayName = 'Wrapper'

type ReactionEmojiProps = {
  $reactionEmoji?: string | null
  $decrement?: boolean
}

export const ReactionEmoji = styled.span<ReactionEmojiProps>`
  transition: top 0.5s cubic-bezier(0.72, 0.01, 0.31, 0.96);
  top: ${({ $decrement }) => ($decrement ? '2rem' : '0rem')};

  ::before {
    content: '${({ $reactionEmoji }) => $reactionEmoji}';
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100%;
    position: absolute;
    left: 0;
    top: -100%;
    margin-top: -2px;
  }
`

ReactionEmoji.displayName = 'ReactionEmoji'

export const ReactionCounter = styled.span`
  opacity: 1;
  transition: opacity 0.3s;
`

ReactionCounter.displayName = 'ReactionCounter'

export const Reaction = styled.button`
  height: 2rem;

  &:not([disabled]):active {
    ${ReactionCounter} {
      opacity: 0;
    }
  }
`

Reaction.displayName = 'Reaction'
